import { background } from './mixins/backgrounds';
import { border, borderRadius } from './mixins/borders';
import { elevation } from './mixins/elevations';
import { horizontalFlow, padding, verticalFlow } from './mixins/flow';
import { text } from './mixins/text';

const mixin = {
  background,
  border,
  borderRadius,
  elevation,
  horizontalFlow,
  padding,
  text,
  verticalFlow,
};

export default mixin;
